import {Component} from '@angular/core';
import {WizardPageBaseComponent} from '@utils-lib';
import {InternethandelInfluencer} from '@nachdigal';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'common-ui-internethandel-influencer',
  templateUrl: './internethandel-influencer.component.html',
  styleUrls: ['./internethandel-influencer.component.scss']
})
export class InternethandelInfluencerComponent extends WizardPageBaseComponent<InternethandelInfluencer> {

  static nutzdatenPath = 'internethandelInfluencer';
  static route = 'internethandel-influencer';

  constructor(protected readonly activatedRoute: ActivatedRoute) {
    super(activatedRoute);
  }

  protected getStammdatenMappingRules(): Map<string, unknown | Array<unknown>> {
    return new Map<string, unknown | Array<unknown>>([]);
  }
}
